import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-cost/unlock_cloud.webp";

function Initiatecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Unlock Cloud <span>Savings Now</span>
            </h2>
            <p>
              Leveraging our optimization strategies to control cloud
              consumption, reduce overall expense, and maximize productivity.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let's Start!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Initiatecloud;
